import { SyncService } from "frontend/services/syncService";
import { useCanvasElementById } from "frontend/subscriptions";
import { RW } from "shared/datamodel/replicache-wrapper/mutators";
import { Frame } from "shared/datamodel/schemas";
import { isIdOfType } from "../canvas-elements-utils";
import FrameBackground from "./frame-background";

export default function FrameBackgroundElement({
  uniqueId,
  syncService,
}: {
  uniqueId: string;
  syncService: SyncService<RW> | null;
}) {
  const element = useCanvasElementById(syncService?.getReplicache(), uniqueId);

  if (!element || !isIdOfType(uniqueId, "frame")) {
    return null;
  }

  const frame = element as Frame;

  return <FrameBackground frame={frame} uniqueId={uniqueId} />;
}
